var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "app-notification-banner",
            class: {
              "app-notification-banner--success": _vm.isTypeSuccess,
              "app-notification-banner--warning": _vm.isTypeWarning,
              "app-notification-banner--danger": _vm.isTypeError
            }
          },
          [
            _c(
              "div",
              { staticClass: "app-notification-banner__section" },
              [
                _vm._t("icon", [
                  _c("div", { staticClass: "app-notification-banner__icon" }, [
                    _vm.isTypeSuccess
                      ? _c("svg", { attrs: { viewBox: "0 0 9.405 7.001" } }, [
                          _c("path", {
                            attrs: {
                              fill: "#fff",
                              d:
                                "M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,1.41,0l5-5a1,1,0,1,0-1.41-1.42Z",
                              transform: "translate(-7.02 -8.499)"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTypeWarning
                      ? _c("svg", { attrs: { viewBox: "0 0 11.268 11.247" } }, [
                          _c("path", {
                            attrs: {
                              fill: "#fff",
                              d:
                                "M13.082,9.636,10.541,7.1a3.851,3.851,0,0,0,.079-.787A4.312,4.312,0,0,0,4.486,2.406a.563.563,0,0,0-.163.911l2.446,2.44L5.757,6.769,3.316,4.323a.571.571,0,0,0-.911.163A4.312,4.312,0,0,0,6.341,10.62a3.851,3.851,0,0,0,.787-.079l2.536,2.541a.565.565,0,1,0,.8-.8L7.707,9.529a.562.562,0,0,0-.534-.146,3.306,3.306,0,0,1-.832.112A3.188,3.188,0,0,1,3.125,6.313a3.373,3.373,0,0,1,.045-.562l2.2,2.21a.562.562,0,0,0,.8,0l1.788-1.8a.562.562,0,0,0,0-.781L5.773,3.17a3.441,3.441,0,0,1,.562-.045A3.188,3.188,0,0,1,9.518,6.313a3.306,3.306,0,0,1-.112.832.562.562,0,0,0,.146.534l2.755,2.755a.565.565,0,1,0,.8-.8Z",
                              transform: "translate(-2.002 -2.002)"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTypeError
                      ? _c("svg", { attrs: { viewBox: "0 0 10.392 10.346" } }, [
                          _c("path", {
                            attrs: {
                              fill: "#fff",
                              stroke: "#fff",
                              "stroke-width": "0.3px",
                              d:
                                "M9.875,8.995l3.935-3.928a.627.627,0,0,0-.887-.887L8.994,8.114,5.066,4.18a.627.627,0,1,0-.887.887L8.114,8.995,4.179,12.923a.627.627,0,1,0,.887.887L8.994,9.875l3.928,3.935a.627.627,0,1,0,.887-.887Z",
                              transform: "translate(-3.798 -3.799)"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "app-notification-banner__section app-notification-banner__section--flex-grow"
              },
              [
                _c("p", { staticClass: "app-notification-banner__title" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t(_vm.title)) + "\n\t\t\t")
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t(_vm.message)))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "app-notification-banner__button",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.closeBanner($event)
                  }
                }
              },
              [_vm._v("\n\t\t\t×\n\t\t")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a184e5b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a184e5b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppNotificationBanner.vue
// module id = null
// module chunks = 